import React from 'react'

const HtmlRawContainerArticle = ({ articleObj }) => {
  return (
    <div>
      <span dangerouslySetInnerHTML={{ __html: articleObj.htmlRawContent }}></span>
    </div>
  )
}

export default HtmlRawContainerArticle
